import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useAlert } from '../components/GlobalAlert';

function ManageSubscriptionPage() {
  const { t } = useLanguage();
  const { showAlert } = useAlert();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading subscription data
    setTimeout(() => {
      setSubscription({
        plan: 'basic',
        status: 'active',
        nextBilling: '2024-12-31',
        autoRenew: true
      });
      setLoading(false);
    }, 1000);
  }, []);

  const handleUpgrade = () => {
    showAlert('🚧 ' + t('featureComingSoon'), 'info');
  };

  const styles = {
    card: {
      backgroundColor: 'white',
      borderRadius: '10px',
      padding: '30px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      maxWidth: '1000px',
      margin: '0 auto',
    },
    title: {
      textAlign: 'center',
      marginBottom: '30px',
      color: '#333',
      fontSize: '28px',
      fontWeight: 'bold',
    },
    subtitle: {
      textAlign: 'center',
      fontSize: '16px',
      color: '#666',
      marginBottom: '30px',
    },
    loading: {
      textAlign: 'center',
      padding: '60px 20px',
      color: '#666',
      fontSize: '16px',
    },
    content: {
      textAlign: 'center',
      padding: '40px 20px',
    },
    icon: {
      fontSize: '64px',
      marginBottom: '20px',
      opacity: 0.5,
    },
    message: {
      fontSize: '18px',
      color: '#666',
      marginBottom: '20px',
    },
    button: {
      backgroundColor: '#3b82f6',
      color: 'white',
      border: 'none',
      padding: '12px 24px',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
    },
  };

  return (
    <div style={styles.card}>
      <h1 style={styles.title}>{t('manageSubscription')}</h1>
      <p style={styles.subtitle}>
        {t('subscriptionDescription')}
      </p>

      {loading ? (
        <div style={styles.loading}>
          💳 {t('loading')}...
        </div>
      ) : (
        <div style={styles.content}>
          <div style={styles.icon}>💳</div>
          <div style={styles.message}>
            {t('subscriptionComingSoon')}
          </div>
          <button 
            style={styles.button}
            onClick={handleUpgrade}
          >
            {t('upgradePlan')}
          </button>
        </div>
      )}
    </div>
  );
}

export default ManageSubscriptionPage; 